<template>
    <div class="form">
        <!-- <Stepper :steps="steps"
                 :step="step" /> -->
        <b-form @submit.stop.prevent="next">
            <b-row class="mb-1 mx-0">
                <b-col class="px-0"
                       sm="3">
                    <div class="label font-weight-bold wrap">*可聯絡時段</div>
                    <div class="label font-weight-bold wrap">(複選)</div>
                </b-col>
                <b-col class="px-0"
                       sm="9">
                    <b-form-checkbox class="mb-1"
                                     size="lg"
                                     v-model="$v.form.connectSeg.$model"
                                     :state="validateState('connectSeg')"
                                     value="0"
                                     :disabled="!edit"
                                     required
                                     @change="changeSelectedOption">
                        全天均可
                    </b-form-checkbox>
                    <div class="d-flex flex-row">
                        <div class="flex-1">
                            <b-form-checkbox class="mb-1"
                                             size="lg"
                                             v-model="$v.form.connectSeg.$model"
                                             :state="validateState('connectSeg')"
                                             value="1"
                                             :disabled="!edit"
                                             required
                                             @change="changeSelectedOption">
                                10:00-12:00
                            </b-form-checkbox>
                            <b-form-checkbox class="mb-1"
                                             size="lg"
                                             v-model="$v.form.connectSeg.$model"
                                             :state="validateState('connectSeg')"
                                             value="2"
                                             :disabled="!edit"
                                             required
                                             @change="changeSelectedOption">
                                13:00-15:00
                            </b-form-checkbox>
                        </div>
                        <div class="flex-1">
                            <b-form-checkbox class="mb-1"
                                             size="lg"
                                             v-model="$v.form.connectSeg.$model"
                                             :state="validateState('connectSeg')"
                                             value="3"
                                             :disabled="!edit"
                                             required
                                             @change="changeSelectedOption">
                                15:00-17:00
                            </b-form-checkbox>
                            <b-form-checkbox class="mb-1"
                                             size="lg"
                                             v-model="$v.form.connectSeg.$model"
                                             :state="validateState('connectSeg')"
                                             value="4"
                                             :disabled="!edit"
                                             required
                                             @change="changeSelectedOption">
                                17:00-20:00
                            </b-form-checkbox>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mb-3 mx-0  border-bottom justify-content-end pb-2">
                <b-col class="px-0"
                       sm="3">
                </b-col>
                <b-col class="px-0"
                       sm="9">
                    <div class="error text-left"
                         v-if="$v.form.connectSeg.$dirty&&!$v.form.connectSeg.timeArrayLength">請選擇您方便聯絡的時間</div>
                </b-col>
            </b-row>
            <b-row class="mb-1 mx-0 d-flex align-items-center">
                <b-col sm="3"
                       class="px-0">
                    <div class="label font-weight-bold pr-1">預約服務及商品諮詢</div>
                </b-col>
                <b-col sm="9"
                       class="px-0">
                    <b-form-input :value="form.product"
                                  readonly></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mb-1 mx-0 d-flex align-items-center">
                <b-col cols="12"
                       class="px-0"
                       sm="3">
                    <div class="label font-weight-bold">*姓氏/姓名</div>
                </b-col>
                <b-col cols="6"
                       class="px-0"
                       sm="5">
                    <b-form-input :value="form.name"
                                  maxLength="10"
                                  @change.native="(e)=>{
                                      onChange(e.target.value, 'name');
                                  }"
                                  :state="validateState('name')"
                                  placeholder="請輸入姓氏/姓名"
                                  autocomplete="off"
                                  :disabled="!edit||this.isDirtLogin"></b-form-input>
                </b-col>
                <b-col cols="6"
                       class="px-0"
                       sm="4">
                    <b-form-radio-group class="d-flex justify-content-center"
                                        size="lg"
                                        v-model="form.sex"
                                        :options="options"
                                        :disabled="!edit"></b-form-radio-group>
                </b-col>
            </b-row>
            <b-row class="mx-0 mb-1">
                <b-col cols="12"
                       class="px-0"
                       sm="3"></b-col>
                <b-col cols="12"
                       class="px-0"
                       sm="9">
                    <div class="error text-left"
                         v-if="$v.form.name.$dirty&&!$v.form.name.required">請輸入姓氏/姓名</div>
                    <div class="error text-left"
                         v-if="$v.form.name.$dirty&&!$v.form.name.nameChar">不得輸入特殊符號、阿拉伯數字或注音符號</div>
                    <div class="error text-left"
                         v-if="$v.form.name.$dirty&&!$v.form.name.nameLengthCheck">中文或英文各不得超過10個字</div>
                </b-col>
            </b-row>
            <b-row class="mb-2 mx-0 d-flex align-items-center">
                <b-col cols="12"
                       class="px-0"
                       sm="3">
                    <div class="label font-weight-bold">*所在地區</div>
                </b-col>
                <b-col cols="12"
                       class="px-0"
                       sm="9">
                    <b-row class="mx-0">
                        <b-col cols="6"
                               class="px-0 pr-2"
                               sm="6">
                            <Select v-model.trim="$v.form.county.$model"
                                    @change.native="countyOnChange"
                                    :state="validateState('county')"
                                    :options="countys"
                                    :disabled="!edit" />
                        </b-col>
                        <b-col cols="6"
                               class="px-0 pl-2"
                               sm="6">
                            <Select v-model.trim="$v.form.zipCode.$model"
                                    :state="validateState('zipCode')"
                                    :options="districts"
                                    :disabled="!edit || !form.county" />
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mx-0 mb-1">
                <b-col cols="12"
                       class="px-0"
                       sm="3"></b-col>
                <b-col cols="12"
                       class="px-0"
                       sm="9">
                    <div class="error text-left"
                         v-if="$v.form.county.$dirty&&$v.form.zipCode.$dirty&&(!$v.form.county.required||!$v.form.zipCode.required)">請選擇您的所在地區</div>
                </b-col>
            </b-row>
            <b-row class="mb-1 mx-0 d-flex align-items-center">
                <b-col sm="3"
                       class="px-0">
                    <div class="label font-weight-bold">*電子郵件</div>
                </b-col>
                <b-col sm="9"
                       class="px-0">
                    <b-form-input :value="form.email"
                                  @change.native="(e)=>{
                                      onChange(e.target.value, 'email');
                                  }"
                                  :state="validateState('email')"
                                  placeholder="請輸入電子郵件信箱"
                                  maxLength="100"
                                  autocomplete="off"
                                  :disabled="!edit||this.isDirtLogin"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mx-0 mb-1 justify-content-end">
                <b-col sm="3"
                       class="px-0">
                </b-col>
                <b-col sm="9"
                       class="px-0">
                    <div class="error text-left"
                         v-if="$v.form.email.$dirty&&!$v.form.email.required">請輸入電子郵件信箱</div>
                    <div class="error text-left"
                         v-if="$v.form.email.required&&$v.form.email.$dirty&&!$v.form.email.emailPattern">電子郵件信箱格式錯誤，請重新輸入</div>
                    <div class="error text-left"
                         v-if="$v.form.email.required&&$v.form.email.emailPattern&&$v.form.email.$dirty&&!$v.form.email.emailLength">限制字數100字</div>

                </b-col>
            </b-row>
            <b-row class="mb-1 mx-0 d-flex align-items-center">
                <b-col sm="3"
                       class="px-0">
                    <div class="label font-weight-bold">*行動電話</div>
                </b-col>
                <b-col sm="9"
                       class="px-0">
                    <b-form-input :value="form.cellphone"
                                  @change.native="(e)=>{
                                      onChange(e.target.value, 'cellphone');
                                  }"
                                  :state="validateState('cellphone')"
                                  placeholder="請輸入行動電話，例：0987654321"
                                  autocomplete="off"
                                  maxLength="10"
                                  type="tel"
                                  :disabled="!edit||this.isDirtLogin"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mx-0 mb-1 justify-content-end">
                <b-col sm="3"
                       class="px-0">
                </b-col>
                <b-col sm="9"
                       class="px-0">
                    <div class="error text-left"
                         v-if="$v.form.cellphone.$dirty&&!$v.form.cellphone.required">請輸入行動電話</div>
                    <div class="error text-left"
                         v-if="$v.form.cellphone.required&&$v.form.cellphone.$dirty&&!$v.form.cellphone.cellphonePattern">行動電話格式錯誤，請重新輸入</div>
                </b-col>
            </b-row>
            <b-row align-h="end"
                   class="mb-1 mx-0 d-flex align-items-center">
                <b-col sm="9"
                       class="px-0 text-warning">
                    <b-icon-exclamation-circle class="mr-1" />請填寫正確的行動電話，以便一次性密碼驗證</b-col>
            </b-row>
            <div v-if="showOpenpoint">
                <b-row class="mb-1 mx-0 d-flex align-items-center">
                    <b-col sm="3"
                        class="px-0">
                        <div class="label font-weight-bold">OP隨機碼(選填)</div>
                    </b-col>
                    <b-col sm="9"
                        class="px-0">
                        <b-form-input :value="form.openPoint"
                                    @change.native="(e)=>{
                                        onChange(e.target.value, 'openPoint');
                                    }"
                                    :state="validateState('openPoint')"
                                    placeholder="請輸入六位數隨機碼"
                                    autocomplete="off"
                                    maxLength="6"
                                    :disabled="!edit||this.isDirtLogin"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mx-0 mb-1 justify-content-end">
                    <b-col sm="3"
                        class="px-0">
                    </b-col>
                    <b-col sm="9"
                        class="px-0">
                        <div class="error text-left"
                            v-if="$v.form.openPoint.$dirty&&(!$v.form.openPoint.openPointPattern||!$v.form.openPoint.openPointLength)">OPENPOINT格式錯誤，請重新輸入</div>
                    </b-col>
                </b-row>
                <b-row align-h="end"
                    class="mb-1 mx-0 d-flex align-items-center">
                    <b-col sm="9"
                        class="px-0">
                        OPEN POINT會員專用，需填寫才算完成任務</b-col>
                </b-row>
            </div>
            <b-row class="mb-1 mx-0 d-flex align-items-center">
                <b-col sm="3"
                       class="px-0">
                    <div class="label font-weight-bold">*指定服務</div>
                    <div class="px-3 label font-weight-bold">業務員</div>
                </b-col>
                <b-col sm="9"
                       class="px-0">
                    <b-form-input :value="form.agentName"
                                  autocomplete="off"
                                  maxLength="10"
                                  :disabled="true"></b-form-input>
                </b-col>
            </b-row>
            <b-form-checkbox class="mb-1"
                             size="lg"
                             v-model="form.isReceiveShare"
                             :value="true"
                             :disabled="!edit">
                我想不定期收到好康訊息
            </b-form-checkbox>
            <b-form-checkbox class="mb-1"
                             size="lg"
                             required
                             :state="validateState('isAgree')"
                             v-model="$v.form.isAgree.$model"
                             :value="true"
                             :disabled="!edit">
                為保護您的權利，請您務必詳細閱讀
                <a href="https://www.fubon.com/life/statement/privacy/data-privacy/"
                   :data-ga="`新保險網站_${newFriend?'新業務':'原業務'}填寫資料_個人資料保護聲明`"
                   target="_blank">個人資料保護聲明</a>，當您登錄及填寫資料完成送出時，即視同您已充分了解並同意
            </b-form-checkbox>
            <b-row class="mx-0 mb-1 justify-content-start"
                   style="padding-left: 30px;">
                <div class="error"
                     v-if="$v.form.isAgree.$dirty&&!$v.form.isAgree.agreeAnswer">請勾選個資保護法應告知事項</div>
            </b-row>
            <b-form-checkbox class="mb-1"
                             size="lg"
                             required
                             :state="validateState('agRuleIsAgree')"
                             v-model= "agRuleIsAgree"
                             :value="true"
                             :disabled="!edit">
                為保護您的權利，請您務必詳細閱讀
                <a href="https://www.fubon.com/life/statement/privacy/data-privacy/"
                   :data-ga="`新保險網站_${newFriend?'新業務':'原業務'}填寫資料_個人資料保護聲明`"
                   target="_blank">個人資料保護聲明</a>，當您登錄及填寫資料完成送出時，即視同您已充分了解並同意
            </b-form-checkbox>
            <b-form-checkbox class="mb-1"
                             size="lg"
                             required
                             :state="validateState1('agRuleIsAgree')"
                             v-model="$v.form1.agRuleIsAgree.$model"
                             :value="true"
                             :disabled="!edit">
                             業務員服務公約
                <b-button v-b-toggle.collapse-1 variant="light">v</b-button>
                <b-collapse id="collapse-1" class="mt-2">
                    <b-card>1.業務人員將先致電聯繫，取得您的同意後，再進行約訪。<br>
                            2.業務人員將會間隔半天以上的時間，分別與您聯繫三次。<br>
                            3.業務人員將於派案後三天內的9:00~20:00點之間與您聯繫，並安排公共場合進行約訪。若因您時間規劃，須於20:00後進行約訪，可與業務人員約定後於公共場合進行。<br>
                            4.業務人員會面時將先出示有照片的壽險公會核發之人身保險業務人員登錄證供您確認身分。<br>
                            5.本公司尊重客戶個人的政治、宗教、性別…立場或傾向，惟雙方會晤時，業務人員會婉辭相關話題討論。<br>
                            6.若您表明無須後續服務聯繫，業務人員將會尊重您的意見。<br>
                            7.若您為同業約訪，本公司業務人員可婉拒進一步服務。<br>
                    </b-card>
                </b-collapse>
            </b-form-checkbox>
            <b-row class="mx-0 mb-1 justify-content-start"
                   style="padding-left: 30px;">
                <div class="error"
                     v-if="$v.form.isAgree.$dirty&&!$v.form.isAgree.agreeAnswer">請勾選個資保護法應告知事項</div>
            </b-row>
            <div v-if="edit">
                <div class="d-flex flex-row justify-content-center align-items-center spacing"
                     v-if="showOtp">
                    <b-button pill
                              type="submit"
                              variant="primary"
                              :data-ga-element="`新保險網站_${newFriend?'新業務':'原業務'}填寫資料_下一步`"
                              class="button">下一步</b-button>
                </div>
                <div class="d-flex flex-row justify-content-center align-items-center spacing"
                     v-if="!showOtp">
                    <b-button pill
                              variant="primary"
                              :data-ga-element="`新保險網站_${newFriend?'新業務':'原業務'}填寫資料_完成送出`"
                              class="button"
                              v-on:click="notOtpReserve">完成送出</b-button>
                </div>
            </div>
        </b-form>
        <b-form @submit.stop.prevent="verifyOtp"
                v-if="showOtp">
            <div class="px-3 py-4 background spacing radius"
                 v-if="!edit">
                <b-row class="mb-1 mx-0 d-flex align-items-center">
                    <b-col sm="4"
                           class="px-0">
                        <div class="label font-weight-bold">請輸入一次性密碼</div>
                    </b-col>
                    <b-col sm="8"
                           class="px-0">
                        <b-form-input :value="otp"
                                      @change.native="(e)=>{
                                        onChange(e.target.value, 'otp');
                                      }"
                                      maxLength="6"
                                      :state="validateState('otp')"
                                      placeholder="請輸入您收到的一次性密碼(共6碼)"
                                      autocomplete="off"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mb-1 mx-0 d-flex align-items-center">
                    <b-col sm="4"
                           class="px-0">
                    </b-col>
                    <b-col sm="8"
                           class="px-0">
                        <div class="error text-left"
                             v-if="$v.otp.$dirty&&!$v.otp.required">請輸入一次性密碼</div>
                        <div class="error text-left"
                             v-if="$v.otp.required&&$v.otp.$dirty&&!$v.otp.lengthCheck">請輸入6碼數字</div>
                    </b-col>
                </b-row>
                <div class="text">
                    若您已超過5分鐘仍未收到一次性密碼，請再按一次
                    <a v-on:click="debounce"
                       :data-ga="`新保險網站_${newFriend?'新業務':'原業務'}_重新發送一次性密碼`"
                       class="text-primary">重新發送一次性密碼
                    </a>
                </div>
            </div>
            <div class="d-flex flex-row justify-content-around align-items-center my-5"
                 v-if="!edit">
                <b-button pill
                          variant="outline-primary"
                          class="button"
                          :data-ga-element="`新保險網站_${newFriend?'新業務':'原業務'}輸入一次性密碼_修改資料`"
                          v-on:click="editForm">修改資料</b-button>
                <b-button pill
                          type="submit"
                          variant="primary"
                          :data-ga-element="`新保險網站_${newFriend?'新業務':'原業務'}輸入一次性密碼_完成送出`"
                          class="button">完成送出</b-button>
            </div>
        </b-form>
        <Notification />
        <Banner :srcId="this.form.srcId" />
        <Modal :show="show"
               :description="description"
               @onClose="onClose">
            <div slot="action"
                 class="d-flex justify-content-center align-items-center my-5">
                <b-button pill
                          variant="primary"
                          class="button"
                          v-on:click="onClose">{{buttonText}}</b-button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
// @ is an alias to /src
// import Stepper from '@/components/Stepper.vue';
import Banner from '@/components/Banner.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import Notification from '@/components/Notification.vue';
import lodash from 'lodash';
import { request } from '@/service';

/* 表單驗證 --- */
const cellphonePattern = (value) => {
    const pattern = /^09\d{8}$/;
    return pattern.test(value);
};

const emailPattern = (value) => {
    // const textPattern = /[^\da-zA-Z@.]/;
    // const textValid = value.match(textPattern);
    const pattern = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value);
};

const emailLength = (value) => {
    return value.length <= 100;
};

const openPointPattern = (value) => {
    const pattern = /[^a-zA-Z]/;
    return !pattern.test(value) || value === '';
};

const openPointLength = (value) => {
    return (value.length === 6) || (value.length === 0);
};

const agAgreeAnswer = (value) => {
    return value === true;
};
const agreeAnswer = (value) => {
    return value === true;
};
const nameLengthCheck = (value) => {
    return value.length <= 10;
};
const timeArrayLength = (value) => {
    return value.length > 0;
};
const nameChar = (value) => {
    value = value.trim();
    const reg = /[\u4e00-\u9fa5]{1}/g;
    const notReg = /[\w|\s|.|·]{1}/g;
    const full = /[\uff00-\uffff]/g;
    const pattern = /[1234567890１２３４５６７８９０]/;
    const cn = value.match(reg) || [];
    const en = value.match(notReg) || [];
    const fullText = value.match(full) || [];
    const number = value.match(pattern);
    return cn.length + en.length + fullText.length === value.length && !number;
};
const lengthCheck = (value) => {
    const pattern = /^\d{6}$/;
    return pattern.test(value);
};
/* --- 表單驗證  */

export default {
    mixins: [validationMixin],
    name: 'FormDataForShare',
    components: {
        // Stepper,
        Banner,
        Select,
        Notification,
        Modal
    },
    beforeRouteEnter(to, from, next) {
        if (from.name !== 'FinishForShare') {
            next();
        } else {
            next({ name: 'Home' });
        }
    },
    mounted() {
        this.$store.dispatch('setHasContent', false);
    },
    created() {
        this.$store.dispatch('setSubHeaderShow', true);
        this.debounce = lodash.debounce(this.resend, 1000);
        this.getData();
        this.getAddresses();
    },
    data() {
        return {
            show: false,
            showOtp: false,
            buttonText: '',
            isError: false,
            edit: true,
            options: [{ text: '先生', value: '男' }, { text: '小姐', value: '女' }],
            districts: [{ text: '請選擇', value: '' }],
            inputValue: '',
            otp: '',
            otpCodeUUID: null,
            description: '',
            resendCount: 0,
            isDirtLogin: false,
            form1: {
                agRuleIsAgree: false,
            },
            form: {
                isReceiveShare: false,
                connectSeg: ['0'],
                sex: '男',
                name: '',
                email: '',
                cellphone: '',
                isAgree: false,
                county: '',
                zipCode: '',
                product: '',
                agentName: '',
                openPoint: ''
            }
        };
    },
    computed: {
        area() {
            return this.$store.state.area;
        },
        newFriend() {
            return this.$store.state.newFriend;
        },
        steps() {
            return this.newFriend ? ['選擇身分', '填寫資料'] : ['選擇身分', '認證身分', '填寫資料'];
        },
        step() {
            return this.newFriend ? 1 : 2;
        },
        countys() {
            const result = this.getAreaList();
            return [{ text: '請選擇', value: '' }, ...result];
        },
        showOpenpoint() {
            return this.form.showOpenpoint;
        },
    },
    validations: {
        form1: {
            agRuleIsAgree: {
                required,
                agAgreeAnswer
            },
        },
        form: {
            name: {
                required,
                nameLengthCheck,
                nameChar
            },
            connectSeg: {
                timeArrayLength
            },
            email: {
                required,
                emailPattern,
                emailLength
            },
            cellphone: {
                required,
                cellphonePattern
            },
            county: {
                required,
            },
            zipCode: {
                required,
            },
            isAgree: {
                required,
                agreeAnswer
            },
            sex: {
                required,
            },
            openPoint: {
                openPointPattern,
                openPointLength
            }
        },
        otp: {
            required,
            lengthCheck
        }
    },
    methods: {
        getAddresses() {
            request({
                method: 'GET',
                api: '/api/zipCode',
            })
                .then(res => {
                    this.$store.dispatch('setArea', res.data.countyList);
                });
        },
        // 將其他網站已完成填寫的值, 帶入表單
        setData(response) {
            this.form = {
                connectSeg: ['0'],
                isAgree: false,
                idNo: response.data.idNo,
                caseId: response.data.caseId,
                srcId: response.data.srcId,
                name: response.data.name || '',
                email: response.data.email || '',
                cellphone: response.data.cellPhone || '',
                county: response.data.county || '',
                zipCode: response.data.zipCode || '',
                product: response.data.productList[0] ? response.data.productList[0].productName : '',
                productId: response.data.productList[0] ? response.data.productList[0].productId : '',
                sex: response.data.sex ? response.data.sex : '男',
                otpCodeUuid: response.data.isDirtLogin ? '' : response.data.otpCodeUuid,
                showOpenpoint: response.data.showOpenpoint,
                agentName: response.data.agentName,
                openPoint: '',
            };

            if (response.data.isDirtLogin || response.data.otpCodeUuid) {
                this.showOtp = false;
                this.isDirtLogin = true;
            } else {
                if (response.data.cellPhone && response.data.otpCodeUuid) {
                    this.showOtp = false;
                    this.isDirtLogin = true;
                } else {
                    this.showOtp = true;
                    this.isDirtLogin = false;
                }
            }
        },
        // 依token取得使用者資訊
        getData() {
            this.$store.dispatch('checkTokenInfoForShare').then(response => {
                this.$store.dispatch('getTokenInfo').then(response => {
                    this.setData(response);
                }).catch((error) => {
                    if (error.status === 200) {
                        this.setData(error);
                    } else if (error.status === 401) {
                        this.buttonText = '確認';
                        this.isError = true;
                        this.description = error.message;
                        this.show = true;
                    } else {
                        this.$notify({
                            group: 'alert',
                            title: error.message,
                            type: 'error',
                        });
                    }
                });
            }).catch((error) => {
                if (error.status === 200) {
                    this.setData(error);
                } else if (error.status === 401 || error.status === 400) {
                    this.buttonText = '確認';
                    this.isError = true;
                    this.description = '欲預約專人服務, 邀請你到富邦人壽「找出你的最佳保障方案」';
                    this.show = true;
                } else {
                    this.$notify({
                        group: 'alert',
                        title: error.message,
                        type: 'error',
                    });
                }
            });
        },
        // 進行預約
        reserve(otpCodeUuid) {
            const requestBody = {
                name: this.form.name.trim(),
                sex: this.form.sex,
                email: this.form.email,
                idNo: this.form.idNo,
                caseId: this.form.caseId,
                srcId: this.form.srcId,
                productId: this.form.productId,
                reserveType: this.newFriend ? 0 : 1,
                cellphone: this.form.cellphone,
                openPoint: this.form.openPoint,
                county: this.form.county,
                connectSeg: this.form.connectSeg.join(','),
                city: this.getDistrict(this.form.zipCode),
                zipCode: this.form.zipCode,
                isAgree: this.form.isAgree ? 1 : 0,
                isReceiveShare: this.form.isReceiveShare ? 1 : 0,
            };
            const requestBodySubmit = this.form.isDirtLogin ? { ...requestBody } : { ...requestBody, otpCodeUuid: otpCodeUuid };

            request({
                method: 'POST',
                api: '/auth/reserve',
                data: requestBodySubmit,
                secure: true
            })
                .then(res => {
                    var url = this.form.reserveFinishUrl;
                    // 含有指定變數，進行變數置換
                    if (url.indexOf('${' + 'nsOrder}') !== -1) {
                        url = url.replace('${' + 'nsOrder}', this.form.caseId);
                        url = url.replace('${' + 'nsItem}', this.cellphoneToNsItem(this.form.cellphone));
                    }

                    if (url.startsWith('http')) {
                        window.location.href = url;
                    } else {
                        this.$router.push({ name: url });
                    }
                }).catch(e => {
                    // 錯誤訊息會回傳多筆, 連接字串與版面顯示
                    if (e.status === 400) {
                        const errorMsg = (() => {
                            let msg = '';
                            e.data.forEach((item, index) => {
                                const br = e.data.length !== 1 && e.data.length !== index + 1 ? '<br />' : '';
                                const number = e.data.length >= 2 ? `${index + 1}. ` : '';
                                msg += (number + item.error + br);
                            });
                            return msg;
                        })();
                        this.$notify({
                            group: 'alert',
                            title: '提醒您：',
                            text: errorMsg,
                            type: 'error',
                        });
                    } else {
                        this.$notify({
                            group: 'alert',
                            title: '提醒您：',
                            text: '系統發生錯誤',
                            type: 'error',
                        });
                    }
                });
        },
        notOtpReserve() {
            this.$v.form.$touch();
            this.$v.form1.$touch();
            if (this.$v.form.$anyError || this.$v.form1.$anyError) {
                return;
            }
            this.reserve();
        },
        // 表單填寫完成, 下一步: 進行預約檢查
        next() {
            this.$v.form.$touch();
            this.$v.form1.$touch();
            if (this.$v.form.$anyError || this.$v.form1.$anyError) {
                return;
            }
            this.requestOtp(); // get first request otp
            this.edit = false;
        },
        // otp 進行驗證
        verifyOtp() {
            this.$v.otp.$touch();
            if (this.$v.otp.$anyError) {
                return;
            }
            request({
                method: 'POST',
                api: '/api/apiVerifyOtp',
                base: true,
                data: {
                    cellphone: this.form.cellphone,
                    otpCodeUUID: this.otpCodeUUID,
                    userOtpCode: this.otp,
                }
            })
                .then(res => {
                    this.reserve(res.data.otpCodeUUID);
                }).catch(e => {
                    if (e.status === 400) {
                        this.$notify({
                            group: 'alert',
                            title: e.data[0].error,
                            type: 'error',
                        });
                    } else if (e.status === 500) {
                        this.$notify({
                            group: 'alert',
                            title: e.message,
                            type: 'error',
                        });
                    }
                });
        },
        // 發送第一次 Otp
        requestOtp() {
            request({
                base: true,
                method: 'POST',
                api: '/api/apiRequestOtp',
                data: { cellphone: this.form.cellphone }
            })
                .then(res => {
                    this.$notify({
                        group: 'alert',
                        title: '一次性密碼已發送至行動電話',
                        type: 'success',
                    });
                    this.otpCodeUUID = res.data.otpCodeUUID;
                }).catch((e) => {
                    // error: show error toast text
                    if (e.status === 500) {
                        this.$notify({
                            group: 'alert',
                            title: e.message,
                            type: 'error',
                        });
                    }
                });
        },
        resend() {
            // 此驗證碼已失效，請再按一次重發送一次密碼
            if (this.resendCount === 10) {
                this.buttonText = '確認';
                this.isError = true;
                this.description = '已超過發送次數，請重新申請';
                this.show = true;
            } else {
                request({
                    base: true,
                    method: 'POST',
                    api: '/api/apiResendOtp',
                    data: {
                        cellphone: this.form.cellphone,
                        otpCodeUUID: this.otpCodeUUID
                    }
                })
                    .then(res => {
                        this.resendCount = res.data.resendCount;
                        this.$notify({
                            group: 'alert',
                            title: '已重新發送一次性密碼',
                            type: 'success',
                        });
                        this.otpCodeUUID = res.data.otpCodeUUID;
                    }).catch(() => {
                        // error: show error toast text
                        this.$notify({
                            group: 'alert',
                            title: '系統發生錯誤',
                            type: 'error',
                        });
                    });
            }
        },
        validateState(name) {
            const { $dirty, $error } = (name === 'otp') ? this.$v.otp : this.$v.form[name];
            return $dirty ? !$error : null;
        },
        validateState1(name) {
            const { $dirty, $error } = this.$v.form1[name];
            return $dirty ? !$error : null;
        },
        onChange(value, name) {
            if (name === 'otp') {
                this.otp = value;
                this.$v.otp.$touch();
            } else {
                this.form[name] = value;
                this.$v.form[name].$touch();
            }
        },
        getDistricts(value) {
            var districts = [];
            this.area.forEach(item => {
                if (item.county === value) {
                    item.districts.forEach(item => {
                        const json = { text: item.name, value: item.zip };
                        districts.push(json);
                    });
                }
            });
            return districts;
        },
        getDistrict(value) {
            let result = '';
            for (let i = 0; i < this.districts.length; i++) {
                if (value === this.districts[i].value) {
                    result = this.districts[i].text;
                }
            }
            return result;
        },
        getAreaList() {
            var countys = [];
            this.area.forEach(item => {
                const json = { text: item.county, value: item.county };
                countys.push(json);
            });
            return countys;
        },
        countyOnChange(e) {
            const val = e.target.value;
            this.districts = [{ text: '請選擇', value: '' }, ...this.getDistricts(val)];
            this.form.zipCode = '';
        },
        editForm() {
            this.edit = true;
            this.otp = '';
            this.$v.otp.$reset();
        },
        onClose() {
            this.show = false;
            if (!this.isError) {
                // 查預約網址
                // window.location.href = '/fubonagent/queryReserve';
            } else {
                // token 失效, 導頁
                const protocol = window.location.protocol;
                const host = window.location.host;

                window.location.href = `${protocol}//${host}/fubonagent/`;
            }
        },
        changeSelectedOption(value) {
            this.$v.form.connectSeg.$touch();
            if (value[value.length - 1] === '0') {
                this.form.connectSeg = ['0'];
            } else {
                const index = this.form.connectSeg.indexOf('0');
                if (index >= 0) {
                    this.form.connectSeg.splice(index, 1);
                }
            }
        },
        cellphoneToNsItem(cellphone) {
            if (cellphone.length !== 10) {
                return cellphone;
            }

            var result = '';

            // 手機第0碼省略
            // 手機第1~3碼轉英文字
            var alphabetMapping = 'JABCDEFGHI';
            for (var i = 1; i <= 3; i++) {
                result += alphabetMapping[cellphone[i]];
            }

            // 結果中間穿插一碼隨機英文，兩碼隨機數字
            var allAlphabetMapping = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            result += allAlphabetMapping[Math.floor(Math.random() * 26)];
            result += Math.floor(Math.random() * 10);
            result += Math.floor(Math.random() * 10);

            // 手機第4~6碼保留
            for (var j = 4; j <= 6; j++) {
                result += cellphone[j];
            }

            // 手機第7碼+1
            var incrementMapping = '1234567890';
            result += incrementMapping[cellphone[7]];

            // 手機第8碼+2
            incrementMapping = '2345678901';
            result += incrementMapping[cellphone[8]];

            // 手機第9碼+3
            incrementMapping = '3456789012';
            result += incrementMapping[cellphone[9]];

            return result;
        }
    }
};
</script>

<style scoped lang="scss">
.label {
    font-size: 18px;
}
@media (max-width: 576px) {
    .form {
        padding: 1rem;
    }
    .wrap {
        display: inline-block;
    }
}
.flex-1 {
    flex: 1;
}
.spacing {
    margin-top: 40px;
    margin-bottom: 40px;
}
.background {
    background-color: #f5f5f5;
}
.text {
    color: #999;
}
.radius {
    border-radius: 5px;
}
</style>
